import { fromJS, merge } from 'immutable';
import { FluxStandardAction } from '__utils/type';
import * as Actions from 'constants/actions'

export interface CartState {
	cartDetails?: any;
}
const rawState: CartState = {
	cartDetails: null
};

const intialState = fromJS(rawState);

export default function cartReducer(
	state = intialState,
	action: FluxStandardAction
) {
	switch (action.type) {
		case Actions.FETCH_CART_DETAILS_SUCCESS:
			return merge(state, fromJS({ cartDetails: action.payload.data }));
		case Actions.FETCH_CART_DETAILS_ERROR:
			return merge(state, fromJS({}));
		default:
			return state;
	}
}
